import React from 'react';
import { langType, variableExtraInfoType } from '../../../constants/types';
import { withLang } from '../../../i18n';

const SummaryExtraInfo = ({ variableExtraInfo, lang }) => (
  <>
    <h3>{variableExtraInfo.title[lang]}</h3>
    <div
      dangerouslySetInnerHTML={// eslint-disable-line react/no-danger
                { __html: variableExtraInfo.info[lang] }
              }
    />
  </>

);

SummaryExtraInfo.propTypes = {
  variableExtraInfo: variableExtraInfoType.isRequired,
  ...langType
};

export default withLang(SummaryExtraInfo);
